import { ErrorContentGenerator, ErrorContentMap, InvalidField, InvalidFieldMessages } from "./getAlertContent";
import { apiErrorContent as forgotPassword1ApiErrors } from './forgotPassword1Errors';
import { ForgotPassword3AlertProps, ForgotPassword3Fields } from "../../components/SmartErrorAlert";
import { hasErrorMessage, hasInvalidField } from "../getApiErrorMessage";

type ForgotPassword3ErrState = 'locked' | 'deactivatedAccount' | 'notFound' | 'unkown';

export const apiErrorContent: ErrorContentMap<ForgotPassword3ErrState> = {
    notFound: forgotPassword1ApiErrors.notFound,
    deactivatedAccount: forgotPassword1ApiErrors.deactivatedAccount,
    locked: forgotPassword1ApiErrors.locked,
    unkown: forgotPassword1ApiErrors.unknown
};

const invalidFieldMessages: InvalidFieldMessages<ForgotPassword3Fields> = {
    newPassword: {
        linkText: 'password',
        messages: {
            empty: 'enter_a_new_password',
            invalid: 'create_password_for_your_account',
            alreadyUsed: 'enter_new_password_different_from_last_six'
        }
    },
    confirmPassword: {
        linkText: 'password',
        messages: {
            empty: 'reenter_new_password'
        }
    }
};

export const forgotPasswordStep3ErrorFns = new ErrorContentGenerator<ForgotPassword3AlertProps, ForgotPassword3Fields, ForgotPassword3ErrState>({
    apiErrorContent,
    invalidFieldMessages,
    invalidFieldHeader: 'complete_items_to_reset_password',
    getRefMap: props => {
        return {
            newPassword: props.newPasswordRef,
            confirmPassword: props.confirmPasswordRef
        }
    },
    getErrState: apiResponse => {
        if (!apiResponse) {
            return null;
        }

        switch (apiResponse.code) {
            case 400:
                const { errors } = apiResponse;
                if (!errors) {
                    return 'unkown';
                }
                const invalidFields = forgotPasswordStep3ErrorFns.getApiInvalidFields(apiResponse);
                if (invalidFields.length) {
                    return null;
                }

                if (hasErrorMessage(errors, 'did not match')) {
                    return 'notFound';
                }
                if (hasErrorMessage(errors, 'user is disabled')) {
                    return 'deactivatedAccount';
                }
                if (hasErrorMessage(errors, 'locked')) {
                    return 'locked';
                }
                return 'unkown';
            default:
                return 'unkown';
        }
    },
    getApiInvalidFields: apiResponse => {
        if (!apiResponse || apiResponse.code !== 400) {
            return [];
        }
        const { errors } = apiResponse;
        if (!errors) {
            return [];
        }

        const invalidFields: InvalidField<ForgotPassword3Fields>[] = [];
        const alreadyUsed = errors.some(x => x.name === 'AlreadyUsed');
        const invalidPassword = hasInvalidField(errors, 'password') || hasInvalidField(errors, 'newPassword');
        const containsUsername = hasErrorMessage(errors, 'password cannot contain username');
        const containsHICN = hasErrorMessage(errors, 'password cannot contain HICN');
        const constainsMBI = hasErrorMessage(errors, 'password cannot contain MBI');

        if (alreadyUsed) {
            invalidFields.push({ name: 'newPassword', type: 'alreadyUsed' });
        }
        if (invalidPassword || containsUsername || containsHICN || constainsMBI) {
            invalidFields.push({ name: 'newPassword', type: 'invalid' });
        }

        return invalidFields;
    },
    isIntermediateStep: false
});